import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import { useContext } from 'react';
import { Link } from 'react-router';

import { type ExperteBlockung } from '../../dtos';
import { BackendConfigContext } from '../../utils';
import { getExperteGesellschaftName } from '../../utils/getExperteGesellschaftName';

type GesellschaftCellProps = { readonly gesellschaft?: ExperteBlockung['experte']['gesellschaft'] };

export const GesellschaftCell = ({ gesellschaft }: GesellschaftCellProps) => {
  const backendConfig = useContext(BackendConfigContext);

  if (!gesellschaft?.gesellschaftId) {
    return '-';
  }

  return (
    <>
      <OpenInNewOutlinedIcon sx={{ mr: 0.5, fontSize: '16px', color: 'text.brand' }} />
      <Link
        target="_blank"
        rel="noopener"
        to={`${backendConfig.HiveAppUrl}/organizations/${gesellschaft.gesellschaftId}`}
      >
        {getExperteGesellschaftName(gesellschaft)}
      </Link>
    </>
  );
};
